import styled from 'styled-components';

export const LoginMessageContainer = styled.div`
  margin: 20px auto;
`;
